module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-BE.f957c686.png";